export const SET_LECTIONS = 'SET_LECTIONS';
export const SET_LECTION = 'SET_LECTION';
export const SET_CREATED_LECTION = 'SET_CREATED_LECTION';
export const EDIT_LECTION = 'EDIT_LECTION';
export const DELETE_LECTION = 'DELETE_LECTION';
export const CLEAR_LECTIONS = 'CLEAR_LECTIONS';
